import $ from "jquery";
import bdapi from "@bd-core/bd-api";

const initBackgroundMusic = () => {
  const music = /** @type {HTMLAudioElement | undefined} */ (
    $(".js-end-music")[0]
  );
  if (!music) return null;

  const play = () => {
    const promise = music.play();
    if (promise) promise.catch(() => {});
  };

  // Browsers may block autoplay with sound, so retry on the first interaction
  const startOnInteraction = () => {
    $(document).off(".end-music");
    play();
  };

  const promise = music.play();
  if (promise) {
    promise.catch(() => {
      $(document).on(
        "click.end-music keydown.end-music touchstart.end-music",
        startOnInteraction,
      );
    });
  }

  return {
    pause: () => music.pause(),
    // Music plays once, so don't restart it after it has finished
    resume: () => {
      if (!music.ended) play();
    },
  };
};

const initRewatchVideo = (backgroundMusic) => {
  const $overlay = $(".js-rewatch-overlay");
  const player = /** @type {HTMLVideoElement | undefined} */ (
    $(".js-rewatch-player")[0]
  );
  if (!$overlay.length || !player) return;

  $(".js-rewatch-video").on("click", (e) => {
    // Opening the video shouldn't also kick off the music via the interaction fallback
    e.stopPropagation();
    $(document).off(".end-music");

    if (backgroundMusic) backgroundMusic.pause();
    $overlay.addClass("is-active");
    player.currentTime = 0;
    const promise = player.play();
    if (promise) promise.catch(() => {});
  });

  const closeOverlay = () => {
    player.pause();
    $overlay.removeClass("is-active");
    if (backgroundMusic) backgroundMusic.resume();
  };

  $(".js-rewatch-close").on("click", (e) => {
    e.stopPropagation();
    closeOverlay();
  });

  // Auto close the popup once the video has finished
  $(player).on("ended", closeOverlay);
};

export const EndPage = () => {
  const isEndPage = $(".end-page").length > 0;
  if (!isEndPage) return false;

  const $btnReplay = $("#replayButton");

  $btnReplay.on("click", function () {
    $btnReplay.attr("disabled", "disabled");

    bdapi
      .post("member/reset-active-game-progress", {})
      .then(() => {
        window.location.href = "/";
      })
      .catch(() => {
        $btnReplay.removeAttr("disabled");
      });
  });

  const backgroundMusic = initBackgroundMusic();
  initRewatchVideo(backgroundMusic);
};
